module.exports = "<div class=\"editorUi-shimmerBar\" :style=\"styles\" />\n";


//////////////////
// WEBPACK FOOTER
// ./src/mixins/components/shimmers/bar/template.html
// module id = /nUt
// module chunks = 0